import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Person\CreatePersonController::__invoke
* @see app/Http/Controllers/Person/CreatePersonController.php
* @route '/api/person'
*/
const CreatePersonController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreatePersonController.url(options),
    method: 'post',
})

CreatePersonController.definition = {
    methods: ["post"],
    url: '/api/person',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Person\CreatePersonController::__invoke
* @see app/Http/Controllers/Person/CreatePersonController.php
* @route '/api/person'
*/
CreatePersonController.url = (options?: RouteQueryOptions) => {
    return CreatePersonController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Person\CreatePersonController::__invoke
* @see app/Http/Controllers/Person/CreatePersonController.php
* @route '/api/person'
*/
CreatePersonController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreatePersonController.url(options),
    method: 'post',
})

export default CreatePersonController